import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from '@okapi/helmet-react';
import { selectPageModelData } from 'store/pageModel';
import { getHostname } from 'selectors';

export const SEOBreadcrumbs = () => {
	const { breadcrumbs } = useSelector(selectPageModelData);
	const host = useSelector(getHostname);

	const itemListElement = breadcrumbs.map(({ label, link }, index) => ({
		'@type': 'ListItem',
		position: index + 1,
		name: label,
		item: `https://${host}${link}`,
	}));

	const jsonLdData = {
		'@context': 'https://schema.org/',
		'@type': 'BreadcrumbList',
		itemListElement,
	};

	return (
		<Helmet>
			<script type="application/ld+json" data-qa="breadcrumbs">
				{JSON.stringify(jsonLdData)}
			</script>
		</Helmet>
	);
};
